import PropTypes from 'prop-types';
import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';

import FormInput from '../../atoms/FormInput';

class FormStationInputWithLabelComponent extends React.Component {
  static get propTypes() {
    return {
      name: PropTypes.string,
      type: PropTypes.string,
      placeholder: PropTypes.string,
      onChange: PropTypes.func,
      validate: PropTypes.any,
      messages: PropTypes.arrayOf(PropTypes.string),
    };
  }

  constructor(props) {
    super(props);

    this.component = this.component.bind(this);
  }

  component(field) {
    return (
      <>
        <FormInput className="c-form_input -mid" {...field} />
        {field.meta.touched && field.meta.error && (
          <Form.Control.Feedback type="invalid">
            <span className="invalid-feedback">{field.meta.error}</span>
          </Form.Control.Feedback>
        )}
      </>
    );
  }

  render() {
    return (
      <dl>
        <dt className="-lbl">最寄り駅</dt>
        <dd>
          <div className="l-cols">
            <div className="c-form_date_col">
              <div className="c-form_date_col_child">
                <Row>
                  <Col>
                    <Field
                      name="line"
                      type={this.props.type}
                      placeholder={this.props.placeholder}
                      component={this.component}
                      validate={this.props.validate}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span>線</span>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      name="station"
                      type={this.props.type}
                      placeholder={this.props.placeholder}
                      component={this.component}
                      validate={this.props.validate}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span>駅</span>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <p className="resume-field-description">
            正式な路線名と駅名を記載してください
            <br />
            例：近鉄 名古屋線 四日市駅、JR 中央線 春日井駅、都営新宿線 神保町駅
          </p>
        </dd>
      </dl>
    );
  }
}

export default FormStationInputWithLabelComponent;
